// extracted by mini-css-extract-plugin
module.exports = {"box":"username-login_box__ueYBY","link":"username-login_link__HxZOt","flex":"username-login_flex__EJoKv"};